/* RESPONSIBLE TEAM: team-inbox-management */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  coalesceFindRequests: true,
});
